import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchForm from '../components/SearchForm';
import { getDestinationImages, getCityName } from '../data/routes';
import { useBooking } from '../context/BookingContext';
import { useLanguage } from '../context/LanguageContext';
import { Wifi, AirVent, Smartphone, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react';

const reviews = [
  { name: { ru: 'Аисте', en: 'Aiste', lv: 'Aiste', lt: 'Aistė', pl: 'Aiste' },
    text: { ru: 'Я выбрала Lux Express для поездки в Таллинн и была приятно удивлена. Автобусы были чистыми, водители были добрыми, время в пути пролетело незаметно за просмотром фильмов!', en: 'I chose Lux Express for my trip to Tallinn and was pleasantly surprised. The buses were clean, the drivers were kind, and the time flew by watching movies!', lv: 'Es izvēlējos Lux Express ceļojumam uz Tallinu un biju patīkami pārsteigta. Autobusi bija tīri, šoferi laipni, laiks lidojumā pagāja nemanot, skatoties filmas!', lt: 'Pasirinkau Lux Express kelionei į Taliną ir buvau maloniai nustebinta. Autobusai buvo švarūs, vairuotojai malonūs, kelionės laikas prabėgo nepastebėtai žiūrint filmus!', pl: 'Wybrałam Lux Express na podróż do Tallinna i byłam mile zaskoczona. Autobusy były czyste, kierowcy mili, czas w podróży minął niepostrzeżenie przy oglądaniu filmów!' } },
  { name: { ru: 'Тоомас', en: 'Toomas', lv: 'Toomass', lt: 'Toomas', pl: 'Toomas' },
    text: { ru: 'Сегодня водитель автобуса, отправлявшегося из Тарту, был очень приятен и выступил с хорошей новогодней речью. Это оставило у меня теплое чувство, он также поблагодарил всех пассажиров за выбор Lux Express.', en: 'Today the bus driver departing from Tartu was very pleasant and gave a nice New Year speech. It left me with a warm feeling, he also thanked all passengers for choosing Lux Express.', lv: 'Šodien autobusa šoferis, kas izbrauca no Tartu, bija ļoti patīkams un teica jauku Jaungada uzrunu. Tas atstāja siltu sajūtu, viņš arī pateicās visiem pasažieriem par Lux Express izvēli.', lt: 'Šiandien autobuso vairuotojas, išvykęs iš Tartu, buvo labai malonus ir pasakė gražią Naujųjų metų kalbą. Tai paliko šiltą jausmą, jis taip pat padėkojo visiems keleiviams už Lux Express pasirinkimą.', pl: 'Dzisiaj kierowca autobusu wyjeżdżającego z Tartu był bardzo miły i wygłosił fajną noworoczną mowę. Zostawiło to ciepłe uczucie, podziękował też wszystkim pasażerom za wybór Lux Express.' } },
  { name: { ru: 'Марис', en: 'Māris', lv: 'Māris', lt: 'Māris', pl: 'Māris' },
    text: { ru: 'Регулярно езжу по маршруту Рига — Вильнюс. Всегда вовремя, комфортные кресла, бесплатный Wi-Fi и горячий кофе. Лучший способ путешествовать между столицами Балтии!', en: 'I regularly travel the Riga — Vilnius route. Always on time, comfortable seats, free Wi-Fi and hot coffee. The best way to travel between Baltic capitals!', lv: 'Regulāri braucu maršrutā Rīga — Viļņa. Vienmēr laikā, ērti krēsli, bezmaksas Wi-Fi un karsta kafija. Labākais veids ceļot starp Baltijas galvaspilsētām!', lt: 'Reguliariai keliauju maršrutu Ryga — Vilnius. Visada laiku, patogios krėslai, nemokamas Wi-Fi ir karšta kava. Geriausias būdas keliauti tarp Baltijos sostinių!', pl: 'Regularnie podróżuję trasą Ryga — Wilno. Zawsze na czas, wygodne fotele, darmowe Wi-Fi i gorąca kawa. Najlepszy sposób podróżowania między stolicami Bałtyku!' } },
  { name: { ru: 'Катажина', en: 'Katarzyna', lv: 'Katažina', lt: 'Katažina', pl: 'Katarzyna' },
    text: { ru: 'Путешествовала из Варшавы в Ригу ночным рейсом. Кресла удобные, можно разложить и поспать. Приехали точно по расписанию. Рекомендую для длинных маршрутов!', en: 'Traveled from Warsaw to Riga on a night bus. The seats are comfortable, you can recline and sleep. We arrived exactly on schedule. Recommended for long routes!', lv: 'Ceļoju no Varšavas uz Rīgu ar nakts reisu. Krēsli ērti, var atlaisties un pagulēt. Ieradāmies precīzi pēc grafika. Iesaku gariem maršrutiem!', lt: 'Keliavau iš Varšuvos į Rygą naktiniu reisu. Sėdynės patogios, galima atlošti ir pamiegoti. Atvykome tiksliai pagal tvarkaraštį. Rekomenduoju ilgiems maršrutams!', pl: 'Podróżowałam z Warszawy do Rygi nocnym kursem. Fotele wygodne, można rozłożyć i pospać. Dojechaliśmy dokładnie według rozkładu. Polecam na długie trasy!' } },
  { name: { ru: 'Йонас', en: 'Jonas', lv: 'Jonass', lt: 'Jonas', pl: 'Jonas' },
    text: { ru: 'Впервые ехал на двухэтажном автобусе Superior из Таллинна в Тарту. Панорамная крыша просто невероятная! Кофемашина с бесплатным кофе и шоколадом — отличный бонус.', en: 'First time riding the double-decker Superior bus from Tallinn to Tartu. The panoramic roof is simply incredible! The coffee machine with free coffee and chocolate is a great bonus.', lv: 'Pirmo reizi braucu ar divstāvu autobusu Superior no Tallinas uz Tartu. Panorāmas jumts ir vienkārši neticams! Kafijas automāts ar bezmaksas kafiju un šokolādi — lielisks bonuss.', lt: 'Pirmą kartą važiavau dviejų aukštų autobusu Superior iš Talino į Tartu. Panoraminis stogas tiesiog neįtikėtinas! Kavos aparatas su nemokama kava ir šokoladu — puikus bonusas.', pl: 'Po raz pierwszy jechałem piętrowym autobusem Superior z Tallinna do Tartu. Panoramiczny dach jest po prostu niesamowity! Ekspres do kawy z darmową kawą i czekoladą — świetny bonus.' } },
  { name: { ru: 'Элина', en: 'Elīna', lv: 'Elīna', lt: 'Elīna', pl: 'Elīna' },
    text: { ru: 'Часто путешествую с детьми на маршруте Рига — Даугавпилс. Дети в восторге от персональных экранов! Ремни безопасности на каждом сиденье — спокойно за безопасность.', en: 'I often travel with children on the Riga — Daugavpils route. The kids love the personal screens! Seat belts on every seat — peace of mind for safety.', lv: 'Bieži ceļoju ar bērniem maršrutā Rīga — Daugavpils. Bērni ir sajūsmā par personālajiem ekrāniem! Drošības jostas katrā sēdeklī — mierīga sajūta par drošību.', lt: 'Dažnai keliauju su vaikais maršrutu Ryga — Daugpilis. Vaikai dievina asmeninius ekranus! Saugos diržai kiekvienoje sėdynėje — ramybė dėl saugumo.', pl: 'Często podróżuję z dziećmi na trasie Ryga — Dyneburg. Dzieci uwielbiają osobiste ekrany! Pasy bezpieczeństwa na każdym siedzeniu — spokój o bezpieczeństwo.' } },
];

const ReviewsSection = ({ t }) => {
  const { lang } = useLanguage();
  const [page, setPage] = useState(0);
  const perPage = typeof window !== 'undefined' && window.innerWidth < 768 ? 1 : 2;
  const totalPages = Math.ceil(reviews.length / perPage);

  return (
    <section className="py-8 md:py-16 bg-white overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[40px] font-semibold text-[#c30909] mb-6 md:mb-10">
          {t('reviews.title')}
        </h2>
        <div className="overflow-hidden mb-6">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${page * 100}%)` }}
          >
            {Array.from({ length: totalPages }).map((_, pageIdx) => {
              const pageReviews = reviews.slice(pageIdx * perPage, pageIdx * perPage + perPage);
              return (
                <div key={pageIdx} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {pageReviews.map((review, idx) => (
                      <div key={idx} className="relative">
                        <div className="text-[#c30909] text-5xl font-serif leading-none mb-3">&ldquo;</div>
                        <p className="text-[16px] md:text-[20px] text-[#333] leading-[1.7] mb-4 italic">
                          {review.text[lang] || review.text.en}
                        </p>
                        <p className="text-[20px] md:text-[24px] font-bold text-[#333]">{review.name[lang] || review.name.en}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage(Math.max(0, page - 1))}
            disabled={page === 0}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <ChevronLeft size={16} strokeWidth={2.5} />
            <span className="font-medium">{t('reviews.prev')}</span>
          </button>
          <div className="flex-1 h-px bg-gray-200" />
          <button
            onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
            disabled={page >= totalPages - 1}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page >= totalPages - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <span className="font-bold">{t('reviews.next')}</span>
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

const destinationDescriptions = {
  ru: {
    'Таллинн': 'Средневековый Старый город, включённый в список ЮНЕСКО. Сочетание истории и современности делает Таллинн одним из самых интересных городов Балтии.',
    'Хельсинки': 'Столица Финляндии с уникальной архитектурой, дизайном и морскими пейзажами. Город, где встречаются Север и Восток.',
    'Нарва': 'Город на границе двух культур с впечатляющей крепостью XIII века. Богатое культурное наследие в сочетании с современными инновациями.',
    'Рига': 'Жемчужина Балтии с крупнейшей коллекцией зданий в стиле ар-нуво в Европе. Старый город — объект ЮНЕСКО.',
    'Тарту': 'Город студентов и науки с живой молодёжной атмосферой. Здесь расположен один из старейших университетов Северной Европы.',
    'Вильнюс': 'Крупнейший Старый город в Восточной Европе, объект ЮНЕСКО. Наследие многих культур и уютные кафе на каждом углу.',
    'Варшава': 'Город контрастов: восстановленный Старый город, современные небоскрёбы и богатая культурная жизнь столицы Польши.',
    'Пярну': 'Летняя столица Эстонии с прекрасными песчаными пляжами и многочисленными спа-курортами. Идеально для отдыха.',
    'Курессааре': 'Волшебный остров Сааремаа со средневековым епископским замком. Место, где время течёт по-особенному.',
    'Даугавпилс': 'Второй по величине город Латвии с уникальной крепостью XIX века и Арт-центром Марка Ротко.',
    'Лиепая': 'Город, где рождается ветер. Прекрасные пляжи, уникальный Каростский квартал и богатые музыкальные традиции.',
    'Хаапсалу': 'Живописный приморский курортный город с епископским замком. Идиллическое место для множества культурных мероприятий.',
    'Хийумаа': 'Остров Хийумаа славится своими маяками, девственной природой, чувством юмора местных жителей и неповторимой островной атмосферой.',
  },
  en: {
    'Tallinn': 'Medieval Old Town, a UNESCO World Heritage Site. The blend of history and modernity makes Tallinn one of the most fascinating Baltic cities.',
    'Helsinki': 'Finland\'s capital with unique architecture, design and seascapes. Where North meets East.',
    'Narva': 'A city on the border of two cultures with an impressive 13th-century fortress. Rich cultural heritage meets modern innovation.',
    'Riga': 'The pearl of the Baltics with Europe\'s largest collection of Art Nouveau buildings. Old Town is a UNESCO site.',
    'Tartu': 'A city of students and science with a lively youthful atmosphere. Home to one of Northern Europe\'s oldest universities.',
    'Vilnius': 'The largest Old Town in Eastern Europe, a UNESCO site. Heritage of many cultures and cozy cafes on every corner.',
    'Warsaw': 'A city of contrasts: restored Old Town, modern skyscrapers and the rich cultural life of Poland\'s capital.',
    'Pärnu': 'Estonia\'s summer capital with beautiful sandy beaches and numerous spa resorts. Perfect for relaxation.',
    'Kuressaare': 'The magical island of Saaremaa with a medieval episcopal castle. A place where time flows differently.',
    'Daugavpils': 'Latvia\'s second largest city with a unique 19th-century fortress and the Mark Rothko Art Centre.',
    'Liepāja': 'The city where the wind is born. Beautiful beaches, unique Karosta quarter and rich musical traditions.',
    'Haapsalu': 'A picturesque seaside resort town with a bishop\'s castle. An idyllic place for many cultural events.',
    'Hiiumaa': 'Hiiumaa island is famous for its lighthouses, pristine nature, sense of humor of its locals and unique island atmosphere.',
  },
  lv: {
    'Tallina': 'Viduslaiku Vecpilsēta, UNESCO mantojuma sarakstā. Vēstures un modernitātes apvienojums.',
    'Helsinki': 'Somijas galvaspilsēta ar unikālu arhitektūru, dizainu un jūras ainavām.',
    'Narva': 'Pilsēta divu kultūru robežā ar iespaidīgu 13. gadsimta cietoksni.',
    'Rīga': 'Baltijas pērle ar lielāko jūgendstila ēku kolekciju Eiropā.',
    'Tartu': 'Studentu un zinātnes pilsēta ar dzīvu jaunības atmosfēru.',
    'Viļņa': 'Lielākā Vecpilsēta Austrumeiropā, UNESCO mantojums.',
    'Varšava': 'Kontrastu pilsēta: atjaunotā Vecpilsēta un moderni debesskrāpji.',
    'Pērnava': 'Igaunijas vasaras galvaspilsēta ar brīnišķīgām pludmalēm.',
    'Kuressāre': 'Burvīgā Sāremā sala ar viduslaiku bīskapa pili.',
    'Daugavpils': 'Latvijas otrā lielākā pilsēta ar unikālu 19. gs. cietoksni.',
    'Liepāja': 'Pilsēta, kur dzimst vējš. Brīnišķīgas pludmales un mūzikas tradīcijas.',
    'Haapsalu': 'Gleznainas jūrmalas kūrorta pilsēta ar bīskapa pili.',
    'Hiiumaa': 'Hiiumā sala slavena ar saviem bākiem un neskarto dabu.',
  },
  lt: {
    'Talinas': 'Viduramžių Senamiestis, UNESCO paveldas objektas. Istorijos ir modernumo derinys.',
    'Helsinkis': 'Suomijos sostinė su unikalia architektūra, dizainu ir jūros peizažais.',
    'Narva': 'Miestas dviejų kultūrų pasienyje su įspūdinga XIII a. tvirtove.',
    'Ryga': 'Baltijos perlas su didžiausia Art Nouveau pastatų kolekcija Europoje.',
    'Tartu': 'Studentų ir mokslo miestas su gyva jaunatviška atmosfera.',
    'Vilnius': 'Didžiausias Senamiestis Rytų Europoje, UNESCO paveldas.',
    'Varšuva': 'Kontrastų miestas: atstatytas Senamiestis ir modernūs dangoraižiai.',
    'Pernu': 'Estijos vasaros sostinė su nuostabiomis paplūdimiais.',
    'Kuressarė': 'Stebuklingoji Saremos sala su viduramžių vyskupo pilimi.',
    'Daugpilis': 'Antrasis pagal dydį Latvijos miestas su unikalia XIX a. tvirtove.',
    'Liepoja': 'Miestas, kuriame gimsta vėjas. Nuostabūs paplūdimiai ir muzikos tradicijos.',
    'Viljandis': 'Vaizdingas pajūrio kurortas su vyskupo pilimi.',
    'Hiiumaa': 'Hiiumos sala garsėja švyturiais ir nekliesta gamta.',
  },
  pl: {
    'Tallinn': 'Średniowieczne Stare Miasto, obiekt UNESCO. Połączenie historii i nowoczesności.',
    'Helsinki': 'Stolica Finlandii z unikalną architekturą, designem i morskimi krajobrazami.',
    'Narwa': 'Miasto na granicy dwóch kultur z imponującą twierdzą z XIII wieku.',
    'Ryga': 'Perła Bałtyku z największą kolekcją budynków secesyjnych w Europie.',
    'Tartu': 'Miasto studentów i nauki z żywą młodzieżową atmosferą.',
    'Wilno': 'Największe Stare Miasto w Europie Wschodniej, obiekt UNESCO.',
    'Warszawa': 'Miasto kontrastów: odbudowane Stare Miasto i nowoczesne wieżowce.',
    'Parnawa': 'Letnia stolica Estonii z pięknymi piaszczystymi plażami.',
    'Kuressaare': 'Magiczna wyspa Sarema ze średniowiecznym zamkiem biskupim.',
    'Dyneburg': 'Drugie co do wielkości miasto Łotwy z unikalną twierdzą z XIX w.',
    'Lipawa': 'Miasto, w którym rodzi się wiatr. Piękne plaże i tradycje muzyczne.',
    'Haapsalu': 'Malownicze nadmorskie miasto uzdrowiskowe z zamkiem biskupim.',
    'Hiiumaa': 'Wyspa Hiuma słynie z latarni morskich i dziewiczej przyrody.',
  },
};

const countryRoutes = {
  estonia: [
    ['tallinn', 'tartu'], ['tallinn', 'narva'], ['tallinn', 'parnu'], ['tallinn', 'viljandi'],
    ['tallinn', 'rakvere'], ['tallinn', 'kuressaare'], ['tallinn', 'haapsalu'], ['tallinn', 'hiiumaa'],
    ['tallinn', 'helsinki'], ['tallinn', 'spb'], ['tallinn', 'riga'], ['tallinn', 'vilnius'],
    ['tallinn', 'warsaw'], ['tartu', 'narva'], ['tartu', 'parnu'], ['tartu', 'viljandi'],
    ['parnu', 'riga'], ['narva', 'rakvere'],
  ],
  latvia: [
    ['riga', 'tallinn'], ['riga', 'vilnius'], ['riga', 'kaunas'], ['riga', 'warsaw'],
    ['riga', 'daugavpils'], ['riga', 'liepaja'], ['riga', 'parnu'], ['riga', 'panevezys'],
    ['riga', 'klaipeda'], ['riga', 'palanga'], ['riga', 'spb'],
  ],
  lithuania: [
    ['vilnius', 'riga'], ['vilnius', 'kaunas'], ['vilnius', 'warsaw'], ['vilnius', 'tallinn'],
    ['vilnius', 'panevezys'], ['vilnius', 'klaipeda'], ['vilnius', 'suwalki'],
    ['kaunas', 'warsaw'], ['kaunas', 'riga'], ['kaunas', 'klaipeda'], ['kaunas', 'suwalki'],
    ['panevezys', 'riga'], ['panevezys', 'warsaw'],
  ],
  russia: [['spb', 'tallinn'], ['spb', 'riga']],
  poland: [
    ['warsaw', 'vilnius'], ['warsaw', 'kaunas'], ['warsaw', 'riga'], ['warsaw', 'tallinn'],
    ['suwalki', 'vilnius'], ['suwalki', 'kaunas'], ['suwalki', 'warsaw'],
  ],
  finland: [['helsinki', 'tallinn'], ['helsinki', 'spb']],
};

const countryTabs = [
  { id: 'estonia', label: { ru: 'ЭСТОНИЯ', en: 'ESTONIA', lv: 'IGAUNIJA', lt: 'ESTIJA', pl: 'ESTONIA' } },
  { id: 'latvia', label: { ru: 'ЛАТВИЯ', en: 'LATVIA', lv: 'LATVIJA', lt: 'LATVIJA', pl: 'ŁOTWA' } },
  { id: 'lithuania', label: { ru: 'ЛИТВА', en: 'LITHUANIA', lv: 'LIETUVA', lt: 'LIETUVA', pl: 'LITWA' } },
  { id: 'russia', label: { ru: 'РОССИЯ', en: 'RUSSIA', lv: 'KRIEVIJA', lt: 'RUSIJA', pl: 'ROSJA' } },
  { id: 'poland', label: { ru: 'ПОЛЬША', en: 'POLAND', lv: 'POLIJA', lt: 'LENKIJA', pl: 'POLSKA' } },
  { id: 'finland', label: { ru: 'ФИНЛЯНДИЯ', en: 'FINLAND', lv: 'SOMIJA', lt: 'SUOMIJA', pl: 'FINLANDIA' } },
];

const countriesTitle = {
  ru: 'Lux Express работает в 6 странах',
  en: 'Lux Express operates in 6 countries',
  lv: 'Lux Express darbojas 6 valstīs',
  lt: 'Lux Express veikia 6 šalyse',
  pl: 'Lux Express działa w 6 krajach',
};

const countriesDesc = {
  ru: 'Самое актуальное расписание вы найдёте через поиск рейсов на нашем сайте.',
  en: 'You can find the most up-to-date schedule through the trip search on our website.',
  lv: 'Aktuālāko sarakstu atradīsiet mūsu mājaslapas reisu meklētājā.',
  lt: 'Naujausią tvarkaraštį rasite mūsų svetainės reisų paieškoje.',
  pl: 'Najaktualniejszy rozkład znajdziesz w wyszukiwarce na naszej stronie.',
};

const fleetData = [
  {
    title: { ru: 'Scania Irizar i6s Efficient', en: 'Scania Irizar i6s Efficient', lv: 'Scania Irizar i6s Efficient', lt: 'Scania Irizar i6s Efficient', pl: 'Scania Irizar i6s Efficient' },
    desc: {
      ru: 'Автобусы Scania Irizar i6s Efficient — это наши новейшие автобусы, оснащённые самыми современными технологиями и удобствами.',
      en: 'Scania Irizar i6s Efficient buses are our newest buses equipped with the most modern technologies and amenities.',
      lv: 'Scania Irizar i6s Efficient autobusi ir mūsu jaunākie autobusi, kas aprīkoti ar modernākajām tehnoloģijām.',
      lt: 'Scania Irizar i6s Efficient autobusai yra mūsų naujausi autobusai su moderniausiomis technologijomis.',
      pl: 'Autobusy Scania Irizar i6s Efficient to nasze najnowsze autobusy wyposażone w nowoczesne technologie.',
    },
    images: [
      'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/LuxExpress_newirizar_8WcXLkqevu.jpg',
    ],
  },
  {
    title: { ru: 'Lux Express Lounge', en: 'Lux Express Lounge', lv: 'Lux Express Lounge', lt: 'Lux Express Lounge', pl: 'Lux Express Lounge' },
    desc: {
      ru: 'В автобусах Lux Express Lounge есть как стандартные кресла, так и кресла Relax, у которых большее пространство для ног, что обеспечивает максимальный комфорт. В Lounge вы можете выбрать одноместное кресло у окна или двухместное кресло с попутчиком.',
      en: 'Lux Express Lounge buses feature both standard and Relax seats with extra legroom for maximum comfort. In Lounge you can choose a single window seat or a double seat.',
      lv: 'Lux Express Lounge autobusos ir gan standarta, gan Relax sēdekļi ar lielāku kāju telpu maksimālam komfortam.',
      lt: 'Lux Express Lounge autobusuose yra ir standartinės, ir Relax sėdynės su didesne vieta kojoms.',
      pl: 'Autobusy Lux Express Lounge oferują zarówno standardowe fotele, jak i fotele Relax z większą przestrzenią na nogi.',
    },
    images: [
      'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/LuxExpress_lounge_dJ4iwso9jT.jpg',
    ],
  },
  {
    title: { ru: 'Lux Express', en: 'Lux Express', lv: 'Lux Express', lt: 'Lux Express', pl: 'Lux Express' },
    desc: {
      ru: 'Автобусы Lux Express рассчитаны на 56 мест. В них нет отдельной зоны "Lounge", но благодаря высокому качеству, поездка будет мягкой и комфортной и на сиденьях класса "стандарт".',
      en: 'Lux Express buses seat 56 passengers. They don\'t have a separate Lounge zone, but thanks to high quality, the ride is smooth and comfortable even in standard class.',
      lv: 'Lux Express autobusos ir 56 vietas. Tajos nav atsevišķas Lounge zonas, bet pateicoties augstajai kvalitātei, brauciens ir ērts arī standarta klasē.',
      lt: 'Lux Express autobusuose yra 56 vietos. Juose nėra atskiros Lounge zonos, bet dėl aukštos kokybės kelionė yra patogi ir standartinėje klasėje.',
      pl: 'Autobusy Lux Express mieszczą 56 pasażerów. Nie mają oddzielnej strefy Lounge, ale dzięki wysokiej jakości podróż jest komfortowa również w klasie standardowej.',
    },
    images: [
      'https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/LuxExpress_standard_OLmsEzQUEU.jpg',
    ],
  },
];

const fleetTitle = {
  ru: 'Познакомьтесь с автобусным парком Lux Express',
  en: 'Meet the Lux Express bus fleet',
  lv: 'Iepazīstieties ar Lux Express autobusu parku',
  lt: 'Susipažinkite su Lux Express autobusų parku',
  pl: 'Poznaj flotę autobusów Lux Express',
};

const FleetSection = ({ lang }) => {
  const [page, setPage] = React.useState(0);

  const bus = fleetData[page];
  const title = bus.title[lang] || bus.title.en;
  const desc = bus.desc[lang] || bus.desc.en;

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[40px] font-semibold text-[#c30909] mb-8 md:mb-10">
          {fleetTitle[lang] || fleetTitle.en}
        </h2>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 mb-6">
          {/* Text */}
          <div className="md:w-[320px] flex-shrink-0">
            <h3 className="text-[20px] md:text-[24px] font-bold text-[#222] mb-4">{title}</h3>
            <p className="text-[15px] md:text-[17px] text-[#555] leading-[1.75]">{desc}</p>
          </div>
          {/* Photo */}
          <div className="flex-1 max-w-[600px]">
            <img src={bus.images[0]} alt={title} className="w-full rounded-lg object-cover" style={{ height: '300px', objectPosition: 'center 65%' }} />
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage(Math.max(0, page - 1))}
            disabled={page === 0}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}>
            <ChevronLeft size={16} strokeWidth={2.5} />
            <span className="font-medium">{lang === 'ru' ? 'НАЗАД' : 'BACK'}</span>
          </button>
          <div className="flex-1 h-px bg-gray-200" />
          <button
            onClick={() => setPage(Math.min(fleetData.length - 1, page + 1))}
            disabled={page >= fleetData.length - 1}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page >= fleetData.length - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707] font-bold'}`}>
            <span>{lang === 'ru' ? 'ВПЕРЕД' : 'NEXT'}</span>
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

const CountriesSection = ({ lang, navigate }) => {
  const [activeTab, setActiveTab] = React.useState('estonia');
  const routes = countryRoutes[activeTab] || [];

  const gn = (id) => getCityName(id, lang);
  const cn = (id) => {
    const map = { estonia: { ru:'ЭСТОНИЯ',en:'ESTONIA',lv:'IGAUNIJA',lt:'ESTIJA',pl:'ESTONIA' },
      latvia: { ru:'ЛАТВИЯ',en:'LATVIA',lv:'LATVIJA',lt:'LATVIJA',pl:'ŁOTWA' },
      lithuania: { ru:'ЛИТВА',en:'LITHUANIA',lv:'LIETUVA',lt:'LIETUVA',pl:'LITWA' },
      poland: { ru:'ПОЛЬША',en:'POLAND',lv:'POLIJA',lt:'LENKIJA',pl:'POLSKA' },
      russia: { ru:'РОССИЯ',en:'RUSSIA',lv:'KRIEVIJA',lt:'RUSIJA',pl:'ROSJA' },
      finland: { ru:'ФИНЛЯНДИЯ',en:'FINLAND',lv:'SOMIJA',lt:'SUOMIJA',pl:'FINLANDIA' }};
    return map[id]?.[lang] || map[id]?.en || id;
  };

  // City positions using real geo coordinates transformed to SVG
  // Transform: lon 20.5-28.5 -> x 40-520, lat 53.5-59.8 -> y 630-10
  const tx = (lon) => 40 + (lon - 20.5) * 60;
  const ty = (lat) => 720 - (lat - 52.0) * 85;
  const mapCities = [
    { id:'helsinki', x:tx(24.94), y:ty(60.17), big:true, anchor:'end' },
    { id:'spb', x:tx(29.0), y:ty(59.93), big:true, anchor:'end' },
    { id:'tallinn', x:tx(24.75), y:ty(59.44), big:true },
    { id:'tartu', x:tx(26.73), y:ty(58.38), big:true },
    { id:'narva', x:tx(28.05), y:ty(59.38), small:true },
    { id:'rakvere', x:tx(26.36), y:ty(59.35), small:true },
    { id:'parnu', x:tx(24.50), y:ty(58.39), small:true, anchor:'end' },
    { id:'haapsalu', x:tx(23.54), y:ty(58.95), small:true, anchor:'end' },
    { id:'kuressaare', x:tx(22.48), y:ty(58.25), small:true, anchor:'end' },
    { id:'viljandi', x:tx(25.59), y:ty(58.36), small:true },
    { id:'riga', x:tx(24.11), y:ty(56.95), big:true, anchor:'end' },
    { id:'liepaja', x:tx(21.01), y:ty(56.51), small:true, anchor:'end' },
    { id:'daugavpils', x:tx(26.53), y:ty(55.87), small:true },
    { id:'vilnius', x:tx(25.28), y:ty(54.69), big:true },
    { id:'kaunas', x:tx(23.90), y:ty(54.90), small:true, anchor:'end' },
    { id:'suwalki', x:tx(22.93), y:ty(54.10), small:true, anchor:'end' },
    { id:'warsaw', x:tx(21.01), y:ty(52.23), big:true },
  ];

  const mapRoutes = [
    ['tallinn','helsinki'],['tallinn','spb'],['tallinn','tartu'],['tallinn','narva'],
    ['tallinn','parnu'],['tallinn','riga'],['tallinn','haapsalu'],
    ['tartu','narva'],['parnu','riga'],
    ['riga','vilnius'],['riga','daugavpils'],['riga','liepaja'],['riga','spb'],
    ['vilnius','kaunas'],['vilnius','warsaw'],['kaunas','warsaw'],
    ['tallinn','vilnius'],
  ];

  const getPos = (id) => { const c = mapCities.find(c2 => c2.id === id); return c ? [c.x, c.y] : [0,0]; };

  const countryLabels = [
    { id:'finland', x:tx(23.5), y:ty(60.5) },
    { id:'estonia', x:tx(25.5), y:ty(58.0) },
    { id:'russia', x:tx(28.5), y:ty(57.5) },
    { id:'latvia', x:tx(25.0), y:ty(56.5) },
    { id:'lithuania', x:tx(24.5), y:ty(55.3) },
    { id:'poland', x:tx(22.0), y:ty(53.2) },
  ];

  const RouteMap = () => (
    <svg viewBox="-10 -10 680 760" className="w-full h-full" style={{ maxHeight: '720px' }}>
      {/* Real country outlines from GeoJSON data */}
      {(() => {
        // Transform: lon 20.5-28.5 -> x 40-520, lat 53.5-59.8 -> y 630-10 (inverted)
        const tx = (lon) => 40 + (lon - 20.5) * 60;
        const ty = (lat) => 720 - (lat - 52.0) * 85;
        const toPath = (coords) => coords.map(([lon,lat], i) => `${i===0?'M':'L'}${tx(lon).toFixed(0)},${ty(lat).toFixed(0)}`).join(' ') + ' Z';

        const estonia = [[24.312863,57.793424],[24.428928,58.383413],[24.061198,58.257375],[23.42656,58.612753],[23.339795,59.18724],[24.604214,59.465854],[25.864189,59.61109],[26.949136,59.445803],[27.981114,59.475388],[28.131699,59.300825],[27.420166,58.724581],[27.716686,57.791899],[27.288185,57.474528],[26.463532,57.476389],[25.60281,57.847529],[25.164594,57.970157],[24.312863,57.793424]];
        const latvia = [[21.0558,56.031076],[21.090424,56.783873],[21.581866,57.411871],[22.524341,57.753374],[23.318453,57.006236],[24.12073,57.025693],[24.312863,57.793424],[25.164594,57.970157],[25.60281,57.847529],[26.463532,57.476389],[27.288185,57.474528],[27.770016,57.244258],[27.855282,56.759326],[28.176709,56.16913],[27.10246,55.783314],[26.494331,55.615107],[25.533047,56.100297],[25.000934,56.164531],[24.860684,56.372528],[23.878264,56.273671],[22.201157,56.337802],[21.0558,56.031076]];
        const lithuania = [[22.731099,54.327537],[22.651052,54.582741],[22.757764,54.856574],[22.315724,55.015299],[21.268449,55.190482],[21.0558,56.031076],[22.201157,56.337802],[23.878264,56.273671],[24.860684,56.372528],[25.000934,56.164531],[25.533047,56.100297],[26.494331,55.615107],[26.588279,55.167176],[25.768433,54.846963],[25.536354,54.282423],[24.450684,53.905702],[23.484128,53.912498],[23.243987,54.220567],[22.731099,54.327537]];

        return (
          <>
            <path d={toPath(estonia)} fill="#ededed" stroke="#ddd" strokeWidth="1.2" opacity="0.7"/>
            <path d={toPath(latvia)} fill="#f0f0f0" stroke="#ddd" strokeWidth="1.2" opacity="0.6"/>
            <path d={toPath(lithuania)} fill="#f0f0f0" stroke="#ddd" strokeWidth="1.2" opacity="0.5"/>
            {/* Poland partial — south of Lithuania */}
            <path d={`M${tx(22.73).toFixed(0)},${ty(54.33).toFixed(0)} L${tx(23.24).toFixed(0)},${ty(54.22).toFixed(0)} L${tx(23.48).toFixed(0)},${ty(53.91).toFixed(0)} L${tx(24.45).toFixed(0)},${ty(53.91).toFixed(0)} L${tx(24.45).toFixed(0)},${ty(53.5).toFixed(0)} L${tx(22).toFixed(0)},${ty(53.5).toFixed(0)} L${tx(21.5).toFixed(0)},${ty(53.8).toFixed(0)} Z`} fill="#f3f3f3" stroke="#ddd" strokeWidth="1" opacity="0.35"/>
            {/* Saaremaa island approx */}
            <path d={`M${tx(22.0).toFixed(0)},${ty(58.35).toFixed(0)} L${tx(22.5).toFixed(0)},${ty(58.55).toFixed(0)} L${tx(23.0).toFixed(0)},${ty(58.45).toFixed(0)} L${tx(23.1).toFixed(0)},${ty(58.25).toFixed(0)} L${tx(22.7).toFixed(0)},${ty(58.1).toFixed(0)} L${tx(22.2).toFixed(0)},${ty(58.15).toFixed(0)} Z`} fill="#ededed" stroke="#ddd" strokeWidth="1" opacity="0.5"/>
            {/* Hiiumaa island approx */}
            <path d={`M${tx(22.0).toFixed(0)},${ty(58.85).toFixed(0)} L${tx(22.4).toFixed(0)},${ty(59.0).toFixed(0)} L${tx(22.7).toFixed(0)},${ty(58.9).toFixed(0)} L${tx(22.5).toFixed(0)},${ty(58.7).toFixed(0)} L${tx(22.1).toFixed(0)},${ty(58.72).toFixed(0)} Z`} fill="#ededed" stroke="#ddd" strokeWidth="1" opacity="0.5"/>
          </>
        );
      })()}
      {/* Route lines */}
      {mapRoutes.map(([a,b], i) => {
        const [x1,y1] = getPos(a);
        const [x2,y2] = getPos(b);
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#aaa" strokeWidth="1.2" opacity="0.4"/>;
      })}
      {/* Country labels */}
      {countryLabels.map((cl, i) => (
        <text key={i} x={cl.x} y={cl.y} fontSize="11" fill="#bbb" fontWeight="600" letterSpacing="3" fontFamily="Inter,sans-serif">
          {cn(cl.id)}
        </text>
      ))}
      {/* Cities */}
      {mapCities.map((c, i) => {
        const name = gn(c.id);
        const displayName = c.big ? name.toUpperCase() : name;
        const r = c.big ? 5 : 3;
        const fs = c.big ? 13 : 10;
        const tx = c.anchor === 'end' ? c.x - 10 : c.x + 10;
        return (
          <g key={i}>
            <circle cx={c.x} cy={c.y} r={r}
              fill={c.big ? 'white' : 'none'}
              stroke={c.big ? '#c30909' : '#bba860'}
              strokeWidth={c.big ? 2 : 1.5}/>
            {c.big && <circle cx={c.x} cy={c.y} r={2} fill="#c30909"/>}
            <text x={tx} y={c.y + (c.big ? 5 : 4)}
              fontSize={fs} fontWeight={c.big ? 800 : 400}
              fill={c.big ? '#222' : '#777'}
              textAnchor={c.anchor || 'start'}
              fontFamily="Inter,sans-serif">{displayName}</text>
          </g>
        );
      })}
    </svg>
  );

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <div className="flex gap-8">
          {/* Left side — title, tabs, routes */}
          <div className="flex-1 min-w-0">
            <h2 className="text-[26px] md:text-[36px] font-semibold text-[#666] mb-3 leading-tight">
              {countriesTitle[lang] || countriesTitle.en}
            </h2>
            <p className="text-[16px] md:text-[18px] text-[#555] mb-8 max-w-[500px] leading-relaxed">{countriesDesc[lang] || countriesDesc.en}</p>

            {/* Country tabs */}
            <div className="flex gap-0 mb-8 border-b-2 border-gray-200 overflow-x-auto" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              {countryTabs.map((tab) => (
                <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                  className={`px-5 py-2.5 text-[13px] font-bold tracking-wide transition-colors relative whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'text-[#333] border-b-[3px] border-[#c30909] -mb-[2px]'
                      : 'text-[#999] hover:text-[#555]'
                  }`}>
                  {tab.label[lang] || tab.label.en}
                </button>
              ))}
            </div>

            {/* Routes grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1 max-w-[700px]">
          {routes.map(([from, to], idx) => {
            const fromName = getCityName(from, lang);
            const toName = getCityName(to, lang);
            return (
              <button key={idx} onClick={() => navigate(`/route/${from}/${to}`)}
                className="flex items-center gap-2 md:gap-3 py-2 text-left hover:text-[#c30909] transition-colors group">
                <span className="text-[13px] md:text-[14px] text-[#333] group-hover:text-[#c30909] whitespace-nowrap">{fromName}</span>
                <svg width="24" height="14" viewBox="0 0 24 14" className="flex-shrink-0 mx-1">
                  <line x1="4" y1="3.5" x2="16" y2="3.5" stroke="#c30909" strokeWidth="1.3"/>
                  <circle cx="19" cy="3.5" r="2.5" fill="none" stroke="#c30909" strokeWidth="1.3"/>
                  <circle cx="5" cy="10.5" r="2.5" fill="none" stroke="#888" strokeWidth="1.3"/>
                  <line x1="8" y1="10.5" x2="20" y2="10.5" stroke="#888" strokeWidth="1.3"/>
                </svg>
                <span className="text-[13px] md:text-[14px] font-medium text-[#333] group-hover:text-[#c30909] whitespace-nowrap">{toName}</span>
              </button>
            );
          })}
            </div>
          </div>
          {/* Right side — map (desktop only) */}
          <div className="hidden lg:block w-[500px] flex-shrink-0 -mt-8">
            <RouteMap />
          </div>
        </div>
      </div>
    </section>
  );
};

const DestinationsSection = ({ t, lang, destinationImages, setSearchParams, navigate }) => {
  const scrollRef = React.useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const getDesc = (city) => {
    const descs = destinationDescriptions[lang] || destinationDescriptions.en;
    return descs[city] || '';
  };
  const learnMore = { ru: 'УЗНАВАЙТЕ', en: 'LEARN MORE', lv: 'UZZINIET', lt: 'SUŽINOKITE', pl: 'DOWIEDZ SIĘ' };

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 10);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  React.useEffect(() => { checkScroll(); }, []);

  const scroll = (dir) => {
    if (scrollRef.current) {
      const cardWidth = 336; // 320px card + 16px gap
      const visibleCards = Math.floor(scrollRef.current.offsetWidth / cardWidth);
      const scrollAmount = cardWidth * Math.max(1, visibleCards - 1);
      scrollRef.current.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
      setTimeout(checkScroll, 600);
    }
  };

  return (
    <section id="destinations" className="py-8 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[40px] font-semibold text-[#c30909] mb-6 md:mb-8">{t('destinations.title')}</h2>
        <div className="relative">
          <div ref={scrollRef} onScroll={checkScroll}
            className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', scrollBehavior: 'smooth' }}>
            {destinationImages.map((dest, idx) => (
              <div key={idx} className="flex-shrink-0 w-[300px] md:w-[380px] snap-start cursor-pointer group"
                onClick={() => {
                  if (dest.id) navigate(`/destination/${dest.id}`);
                }}>
                <div className="relative rounded-lg overflow-hidden aspect-[4/3] mb-4">
                  <img src={dest.url} alt={dest.city} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <h3 className="text-xl font-bold text-[#222] mb-2">{dest.city}</h3>
                <p className="text-[15px] text-[#444] leading-relaxed mb-3 line-clamp-3">{getDesc(dest.city)}</p>
                <p className="text-[15px] font-bold text-[#c30909] tracking-wide">{learnMore[lang] || learnMore.en}</p>
              </div>
            ))}
          </div>
        </div>
        {/* Navigation buttons */}
        <div className="flex items-center gap-4 mt-4">
          <button
            onClick={() => scroll(-1)}
            disabled={!canScrollLeft}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${!canScrollLeft ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <ChevronLeft size={16} strokeWidth={2.5} />
            <span className="font-medium">{t('reviews.prev')}</span>
          </button>
          <div className="flex-1 h-px bg-gray-200" />
          <button
            onClick={() => scroll(1)}
            disabled={!canScrollRight}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${!canScrollRight ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <span className="font-bold">{t('reviews.next')}</span>
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
        </div>
      </div>
      <style>{`.scrollbar-hide::-webkit-scrollbar { display: none; }`}</style>
    </section>
  );
};

const featureCards = [
  { titleKey: 'features.time.title', descKey: 'features.time.desc' },
  { titleKey: 'features.comfort.title', descKey: 'features.comfort.desc' },
  { titleKey: 'features.tv.title', descKey: 'features.tv.desc' },
  { titleKey: 'features.internet.title', descKey: 'features.internet.desc' },
];

const amenityIcons = [
  { icon: AirVent, key: 'amenity.ac' },
  { icon: Wifi, key: 'amenity.wifi' },
  { icon: Smartphone, key: 'amenity.eticket' },
  { icon: ShieldCheck, key: 'amenity.seatbelts' },
  { icon: null, key: 'amenity.wc', label: 'WC' },
];

const tipKeys = ['tips.2', 'tips.3', 'tips.4', 'tips.5'];

const HomePage = () => {
  const navigate = useNavigate();
  const { setSearchParams } = useBooking();
  const { t, lang } = useLanguage();
  const destinationImages = getDestinationImages(lang);

  return (
    <div>
      {/* Hero */}
      <section
        className="relative min-h-[480px] md:min-h-[520px] lg:min-h-[560px] flex items-center justify-center bg-[#1a1a2e]"
      >
        <div className="absolute inset-0 overflow-hidden">
          <img
            src="https://www.spaestonia.ee/resort/wp-content/uploads/2024/08/Luxexpress-1.jpg"
            alt="Lux Express"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 max-w-[1280px] w-full mx-auto px-3 md:px-4 pt-20 md:pt-28 pb-6 md:pb-12" style={{ WebkitFontSmoothing: 'antialiased', textRendering: 'optimizeLegibility' }}>
          <div className="text-left mb-6 md:mb-10 md:max-w-[600px]">
            <h1 className="text-[36px] md:text-[56px] font-semibold text-white drop-shadow-lg" style={{ lineHeight: 1.1, letterSpacing: '-0.5px' }}>{t('hero.title')}</h1>
            <p className="text-[22px] md:text-[40px] text-white/90 mt-3 md:mt-4 font-normal" style={{ lineHeight: 1.4 }}>{t('hero.subtitle')}</p>
          </div>
          <SearchForm />
        </div>
      </section>

      {/* Red divider line */}
      <div className="h-1 bg-[#c30909]" />

      {/* Features — Why passengers prefer Lux Express */}
      <section id="features" className="py-8 md:py-16 bg-white">
        <div className="max-w-[1280px] mx-auto px-3 md:px-4">
          <h2 className="text-[28px] md:text-[42px] font-semibold text-[#c30909] mb-6 md:mb-10">{t('features.title')}</h2>
          {/* 4 feature cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-12">
            {featureCards.map((f, idx) => (
              <div key={idx}>
                <h3 className="text-[20px] md:text-[24px] font-medium text-[#222] mb-3">{t(f.titleKey)}</h3>
                <p className="text-[15px] md:text-[16px] text-[#555] leading-relaxed">{t(f.descKey)}</p>
              </div>
            ))}
          </div>
          {/* Amenity icons divider */}
          <div className="border-t pt-5 md:pt-10">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-x-3 gap-y-4 md:gap-6">
              {amenityIcons.map((a, idx) => (
                <div key={idx} className="flex md:flex-col items-center md:items-center gap-3 md:gap-0 min-w-0">
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-[#f0f0f1] flex items-center justify-center md:mb-3 flex-shrink-0">
                    {a.icon ? <a.icon size={22} className="text-[#333] md:w-[28px] md:h-[28px]" strokeWidth={1.5} /> : <span className="text-sm md:text-base font-bold text-[#333]">{a.label}</span>}
                  </div>
                  <p className="text-[13px] md:text-[16px] font-medium text-[#333] leading-snug break-words flex-1 md:flex-none md:text-center md:w-full">{t(a.key)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Destinations gallery — horizontal scroll with descriptions */}
      <DestinationsSection t={t} lang={lang} destinationImages={destinationImages} setSearchParams={setSearchParams} navigate={navigate} />

      {/* Countries & Routes */}
      <CountriesSection lang={lang} navigate={navigate} />

      {/* Bus Fleet */}
      <FleetSection lang={lang} />

      {/* Passenger Reviews */}
      <ReviewsSection t={t} />

    </div>
  );
};

export default HomePage;
